import { Navigate, useNavigate } from "react-router-dom";
import { BlockStack } from "../blocks";
import { useBootstrap } from "../components/BootstrapProvider";
import { useCart } from "../components/CartProvider";
import { useAddressSheet } from "../components/AddressSheetProvider";
import { formatAddress } from "../components/AddressForm";

/** Stable ordering destination, independent of the pages built by the owner. */
export function Menu() {
  const { bootstrap, t } = useBootstrap();
  const { session, selectStorefront } = useCart();
  const address = useAddressSheet();
  const navigate = useNavigate();
  const only = bootstrap.storefronts.length === 1 ? bootstrap.storefronts[0] : undefined;
  if (only) return <Navigate to={`/vitrina/${encodeURIComponent(only.slug)}`} replace />;
  return <BlockStack fallbackHeading="Alege restaurantul" blocks={[
    { id: "comanda-adresa", type: "address-bar", config: {} },
    { id: "comanda-restaurante", type: "storefront-grid", config: { title: "De unde comanzi azi?", requireAddress: false, showSearch: true, showFilters: true } },
  ]} ctx={{
    t,
    addressLabel: session.address ? formatAddress(session.address) : null,
    requestAddress: () => address.open(),
    openStorefront: slug => { selectStorefront(slug); navigate(`/vitrina/${encodeURIComponent(slug)}`); },
  }} />;
}
